module.exports = __webpack_public_path__ + "img/thunes.d0119b2f.png";